import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Reviews: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      {/* Page Header */}
      <div className="relative text-white py-12 sm:py-16 md:py-20 lg:py-24 mt-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1516534775068-ba3e7458af70?w=1920&h=600&fit=crop&q=80"
            alt="Reviews"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/50"></div>
        </div>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <p className="text-gray-200 mb-2 sm:mb-3 text-xs sm:text-sm font-medium tracking-wider">참여마당</p>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-3 sm:mb-4">수강후기</h1>
          <div className="w-16 sm:w-20 h-1 bg-white/70"></div>
        </div>
      </div>

      {/* Content Section */}
      <div className="flex-1 py-8 sm:py-10 md:py-12 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center py-16 sm:py-20">
            <p className="text-gray-500 text-base sm:text-lg">등록된 후기가 없습니다.</p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Reviews;
